/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import styled from 'styled-components';
import { CardAttr } from '../widgets/card-attr';
import { connect } from 'react-redux';
import { colors } from '../../themes';

const UserContainer = styled.section`
  h2 {
    padding: 0;
    margin: 0em 0em 0.5em;
  }
`;
const Wrapper = styled.section`
  > span {
    font-size: 0.9em;
    color: ${colors.baseColors.grey};
  }
`;

export function UserData({ user }: any) {
  return (
    <UserContainer>
      <h2>{user.displayName}</h2>
      <CardAttr title="email">{user.email}</CardAttr>
      <CardAttr title="email verified">{user.emailVerified ? 'Yes' : 'No'}</CardAttr>
      <CardAttr title="username">{user.username}</CardAttr>
    </UserContainer>
  );
}

function $UsersCard(props: any) {
  if (!props.users) {
    return null;
  }
  return (
    <Wrapper>
      <span>Users:</span>
      {props.users.map((u: any) => (
        <UserData key={u.id} user={u} />
      ))}
    </Wrapper>
  );
}

export const UsersCard = connect((s: any) => ({
  users: s.serviceProviders.myUsers
}))($UsersCard);
